export default __webpack_public_path__ + "static/card-1-19c441f63208f604af711024f7d764a6.png";